module.exports = __webpack_public_path__ + "img/select-type__03.9046f912.png";